import type { CSSProperties } from 'react'
import { QR_ACCENT_COLOR } from './config'

export const resolveQrAccentColor = (color?: string | null): string =>
    typeof color === 'string' && /^#[0-9a-f]{6}$/i.test(color.trim())
        ? color.trim()
        : QR_ACCENT_COLOR

// null, отсутствующий или некорректный цвет с бэка заменяем значением из config.ts.
export const createQrThemeStyle = (color?: string | null): CSSProperties => {
    const accent = resolveQrAccentColor(color)
    const rgb = [1, 3, 5].map((offset) => parseInt(accent.slice(offset, offset + 2), 16)).join(', ')
    return {
        '--lio-accent': accent,
        '--lio-accent-rgb': rgb,
    } as CSSProperties
}

export const QR_THEME_STYLE = createQrThemeStyle()
